var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { opacity: "0.7" } }, [
        _c("path", {
          attrs: {
            d:
              "M7.99935 8.66634C8.36754 8.66634 8.66602 8.36786 8.66602 7.99967C8.66602 7.63148 8.36754 7.33301 7.99935 7.33301C7.63116 7.33301 7.33268 7.63148 7.33268 7.99967C7.33268 8.36786 7.63116 8.66634 7.99935 8.66634Z",
            stroke: "#002F4A",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M12.666 8.66634C13.0342 8.66634 13.3327 8.36786 13.3327 7.99967C13.3327 7.63148 13.0342 7.33301 12.666 7.33301C12.2978 7.33301 11.9993 7.63148 11.9993 7.99967C11.9993 8.36786 12.2978 8.66634 12.666 8.66634Z",
            stroke: "#002F4A",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M3.33268 8.66634C3.70087 8.66634 3.99935 8.36786 3.99935 7.99967C3.99935 7.63148 3.70087 7.33301 3.33268 7.33301C2.96449 7.33301 2.66602 7.63148 2.66602 7.99967C2.66602 8.36786 2.96449 8.66634 3.33268 8.66634Z",
            stroke: "#002F4A",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }